import { render, staticRenderFns } from "./adminpsb.vue?vue&type=template&id=7be6645e&"
import script from "./adminpsb.vue?vue&type=script&lang=js&"
export * from "./adminpsb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports